module.exports = __webpack_public_path__ + "static/media/umbrella-blue.369319c9.png";